import { set } from 'vue'

// Initial state factory function
const getDefaultState = () => {
  return {
    snackbar: {
      open: false,
      text: null,
      color: null
    },
    dialog: {
      open: false,
      persistent: true,
      component: null,
      width: null
    },
    vDataTableDefaults: {
      noResultsText: 'Δεν βρέθηκαν αποτελέσματα',
      noDataText: 'Δεν βρέθηκαν αποτελέσματα',
      loadingText: 'Παρακαλώ περιμένετε...',
      headerProps: {
        sortByText: 'Ταξινόμηση ανά'
      },
      footerProps: {
        itemsPerPageText: 'Αντικείμενα ανά σελίδα',
        itemsPerPageAllText: 'Όλα'
      }
    }
  }
}

export default {
  state: getDefaultState(),
  mutations: {
    SET_SNACKBAR(state, { open, text, color = null }) {
      set(state.snackbar, 'open', open)
      set(state.snackbar, 'text', text)
      set(state.snackbar, 'color', color)
    },
    toggleDialog(state, dialog) {
      set(state, 'dialog', {
        ...state.dialog,
        ...dialog
      })
    },
    RESET_STATE(state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    toggleSnackbar({ commit }, snackbar) {
      commit('SET_SNACKBAR', { open: true, ...snackbar })
    }
  }
}
